var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from 'common/store/use-store-actions';
import { useChatsListStore } from './service-store/service-store';
import { chatsListQueryKeys } from '../api-tags';
export var useChatsListActions = function () {
    var actions = useStoreActions(useChatsListStore);
    var queryClient = useQueryClient();
    return useMemo(function () { return (__assign(__assign({}, actions), { invalidateChatsListCacheAction: function () {
            return queryClient.invalidateQueries({
                queryKey: chatsListQueryKeys.all,
                refetchType: 'none',
            });
        }, refreshChatsListAction: function () {
            actions.prepareChatsListRefresh();
            return queryClient.invalidateQueries({
                queryKey: chatsListQueryKeys.all,
            });
        } })); }, [actions, queryClient]);
};
